import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@patternfly/react-core';
import { PencilAltIcon, TrashIcon } from '@patternfly/react-icons';
import { useContext, useState } from 'react';
import { isDefined, ROOT_PATH } from '../../utils';
import { useFieldValue } from '../../hooks/field-value';
import { SchemaContext } from '../../providers/SchemaProvider';
import { ArrayFieldWrapper } from '../ArrayField/ArrayFieldWrapper';
import { ObjectFieldGrouping } from './ObjectFieldGrouping';
export const ObjectField = ({ propName, onRemove: onRemoveProps }) => {
    var _a, _b;
    const { schema } = useContext(SchemaContext);
    const { value, onChange } = useFieldValue(propName);
    const [isExpanded, setIsExpanded] = useState(isDefined(value));
    const label = (_b = (_a = schema.title) !== null && _a !== void 0 ? _a : propName.split('.').pop()) !== null && _b !== void 0 ? _b : propName;
    const onSet = () => {
        setIsExpanded(true);
    };
    const onRemove = () => {
        if (isDefined(onRemoveProps)) {
            onRemoveProps(propName);
            return;
        }
        onChange(undefined);
        setIsExpanded(false);
    };
    if (propName === ROOT_PATH || (!schema.title && !isDefined(onRemoveProps))) {
        return _jsx(ObjectFieldGrouping, { propName: propName });
    }
    return (_jsx(ArrayFieldWrapper, { propName: propName, type: "object", title: label, description: schema.description, defaultValue: schema.default, actions: _jsxs(_Fragment, { children: [!isExpanded && (_jsx(Button, { variant: "plain", "data-testid": `${propName}__set`, "aria-label": "Set object", title: "Set object", onClick: onSet, icon: _jsx(PencilAltIcon, {}) })), isExpanded && (_jsx(Button, { variant: "plain", "data-testid": `${propName}__remove`, "aria-label": "Remove object", title: "Remove object", onClick: onRemove, icon: _jsx(TrashIcon, {}) }))] }), children: isExpanded && _jsx(ObjectFieldGrouping, { propName: propName }) }));
};
//# sourceMappingURL=ObjectField.js.map